import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function strictEmailValidator(control: AbstractControl): ValidationErrors | null {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailPattern.test(control.value) ? null : { invalidEmail: true };
}

export function passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const password = control.get('password');
  const confirmPassword = control.get('confirmPassword');
  
  if (password && confirmPassword && password.value !== confirmPassword.value) {
    return { passwordMismatch: true };
  }
  return null;
}
// Custom Validator for ensuring the termination date is not before the joining date
export function terminationDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const joiningDate = control.get('joiningDate')?.value;
    const terminationDate = control.get('terminationDate')?.value;

    // Check if joiningDate is null
    if (!joiningDate) {
      return { joiningDateRequired: true };  // Error if joining date is null
    }

    // Check if terminationDate is earlier than joiningDate
    if (terminationDate && new Date(terminationDate) < new Date(joiningDate)) {
      return { terminationBeforeJoining: true };  // Error if termination date is before joining date
    }

    return null;  // No error
  };
}


export function endDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const startDate = control.get('startTime')?.value;
    const endDate = control.get('endTime')?.value;

    // Check if joiningDate is null
    if (!startDate) {
      return { startDateRequired: true };  // Error if joining date is null
    }

    // Check if terminationDate is earlier than joiningDate
    if (endDate && new Date(endDate) < new Date(startDate)) {
      return { endBeforeStart: true };  // Error if termination date is before joining date
    }

    return null;  // No error
  };

  
}


export function employeeOrGroupValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const employees = control.get('employees')?.value || [];
    const groupId = control.get('groupId')?.value;

    if ((!employees.length && !groupId) || (employees.length && groupId)) {
      // If neither is selected or both are selected, return error
      return { employeeOrGroupRequired: true };
    }

    return null;  // Return null if the validation passes
  };
}